import styled from 'styled-components';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
    display: block;
    padding-top: 10px;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 600px;
  padding: 20px;
  margin: 0 auto;
  border: solid 0.8px #d9d9d9;
  background-color: #f7f7f7;

  .invalid {
    padding: 5px 5px 5px 5px;
    font-size: 11px;
    color: red;
  }
  .item {
    padding: 0 15px;
    margin: 1rem 0;
    min-height: 90px;
  }

  h4 {
    color: #74a50a !important;
  }

  h2.title {
    font-size: 24px;
    font-weight: normal;
    text-align: center;
    padding: 2rem 0 3rem;
  }
  .borderTest {
    border: 1px solid blue;
  }

  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }

  div.BoxAuthContainer {
    margin: 20px auto;
  }
  hr {
    opacity: 0.1;
    display: block;
    margin: 30px 0;
  }
  div.title {
    padding: 45px;
    h2 {
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      text-align: center;
      color: #282828;
      span {
        color: #74a50a;
        font-weight: bold;
      }
    }
  }
`;

export const Content = styled.div`
  width: 75%;
  margin: 0 auto;

  div.ant-row {
    margin-bottom: 25px;
  }

  p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    color: #282828;
  }
`;

export const BoxForm = styled.div`
  .gleasonpros > div {
    width: calc(100% / 3);
  }
  .gleasonpros div > span {
    min-height: 30px;
  }
  .gleasonpros > div:nth-child(3):before {
    content: '+';
    position: absolute;
    top: 55%;
    left: -4px;
  }
  .gleasonpros > div:nth-child(3):after {
    content: '=';
    position: absolute;
    top: 55%;
    right: -4px;
  }
  .gleasonpros div .item div {
    width: 100% !important;
  }
  .gleasonpros #gleason_pros {
    pointer-events: none;
    background: transparent;
  }

  div.boxUltimaPontuacaoNPS {
    padding-top: 2px;
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      text-align: left;
      color: #74a50a;
    }
    input {
      width: 80px;
    }
  }
  div.ButtonTooltip {
    color: #fff;
    span {
      width: 13px;
      height: 13px;
      background-color: #b4b4b4;
      border-radius: 50%;
      display: block;
      color: #fff;
      font-size: 8px;
      display: fex;
      justify-content: center;
      align-items: center;
      margin-left: 3px;
    }
  }
`;

export const TitleSection = styled.h4`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  text-align: left;
  color: #74a50a;
  margin-bottom: 20px;
`;

export const BoxInput = styled.div`
  .checkboxException:before {
    content: '/';
    padding-right: 5px;
    font-size: 15px;
  }

  .w-100 {
    width: 100%;
  }

  h3.title {
    width: 100%;
    padding-bottom: 1.5rem;
    padding-top: 2rem;
  }

  div.radiosProtocolos {
    .ant-col {
      margin-bottom: 10px;
      span:nth-child(1) {
        float: left;
      }
      label {
        cursor: pointer;
      }
      p {
        font-size: 13px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        letter-spacing: 0.01px;
        text-align: left;
        color: #1f5f6f;
        position: absolute;
        top: 4px;
        left: 50px;
        right: 10px;
      }
    }
  }

  width: 100%;
  /* padding: 20px; */
  display: flex;
  flex-wrap: wrap;

  /* border: 1px solid blue; */
  p {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
  }

  /* input */

  input[type='text'],
  input[type='number'] {
    width: 100%;
    background: #ffffff;
    border: 0;
    border-radius: 4px;
    height: 35px;
    padding: 0 15px;
    color: #282828;
    margin: 0 0 0 0;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: 1px solid #c7c7c794;
    &::placeholder {
      color: #282828;
      font-size: 12px;
    }
    &:disabled {
      background-color: #f6f6f6;
    }
  }

  span.errorField {
    color: #cc0000;
    font-size: 9px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    letter-spacing: 0px;
    margin-bottom: 5px;
  }

  div.inlineRadios {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const BoxRadios = styled.div`
  width: 201.7px;
  padding: 10px 20px;
  border-radius: 3px;
  border: solid 0.5px;
  border-color: ${props => (props.active ? '#74a50a' : 'transparent')};
  background-color: ${props =>
    props.active ? 'rgba(116, 165, 10, 0.16)' : ''};
  &.v-large {
    width: 100%;
  }
  p {
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.01px;
    text-align: left;
    color: ${props => (props.accessLevelActive ? '#74a50a' : '#999999')};
    margin-top: 7px;
  }

  .item-description {
    white-space: normal;
    font-size: 12px;
    line-height: 14px;
    font-weight: normal;
  }

  .ant-radio-wrapper {
    display: flex;
    color: #74a50a;
    font-size: 13px;
    font-weight: bold;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum', 'tnum';
    cursor: pointer;
    white-space: inherit;
    span {
      color: ${props => (props.active ? '#74a50a' : '#898989')};
      font-size: 13px;
      font-weight: bold;
      line-height: 18px;
      float: left;
      display: inline-block;
      letter-spacing: 0px;

      display: inline-flex;
      flex-wrap: wrap;
      align-items: center;
    }
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #74a50a;
    &:hover {
      border-color: #74a50a;
    }
    &:focus {
      border-color: #74a50a;
    }
  }

  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #74a50a;
  }

  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: #fff;
    background: #74a50a;
    border-color: #74a50a;
  }
  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
    color: #fff;
    background: #74a50a;
    border-color: #74a50a;
  }

  .ant-radio-inner::after {
    position: absolute;
    top: 4px;
    left: 4px;
    display: table;
    width: 12px;
    height: 12px;
    background-color: #74a50a;
    border-top: 0;
    border-left: 0;
    border-radius: 8px;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    opacity: 0;
    -webkit-transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    content: ' ';
  }
  .ant-radio-inner {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 22px;
    height: 22px;
    background-color: #fff;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px;
    border-radius: 100px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

  /*  */

  .ant-radio-checked::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #74a50a;
    border-radius: 50%;
    visibility: hidden;
    -webkit-animation: antRadioEffect 0.36s ease-in-out;
    animation: antRadioEffect 0.36s ease-in-out;
    animation-fill-mode: none;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    content: '';
  }
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 10px;
  display: block;
  > span {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: left;
    color: #999999;
  }
`;

export const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  button {
    /* width: 90px; */
    height: 34px;
    padding: 0 50px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
  }
`;
